<template>
  <div class="fileUpload-container">
    <div class="fileUpload-bordered">
      <div v-if="!!description" class="mb-2">
        {{ description }}
      </div>
      <div v-if="!readonly" class="inner-file head">
        <div :class="{ 'label-wrapper_disabled': disabled }">
          <label class="input-file-btn" for="file-input">
            {{ label }}
            <input
              type="file"
              :multiple="!isOnce"
              :disabled="disabled"
              id="file-input"
              class="input-file"
              :accept="accept"
              v-on:change="fileChanged($event)"
            />
          </label>
        </div>
        <div v-if="isEmptyValue && showEmpty" class="fileUpload__empty">Файлы не выбраны</div>
        <div v-if="v$.modelValue.$error" class="invalid-msg">
          <div v-if="v$.modelValue.required.$invalid" class="fileUpload__error">Загрузите файл</div>
        </div>
      </div>

      <slot name="preview" />
    </div>
    <div v-if="!isValidFileExtension" class="invalid-msg">Недопустимый формат файла</div>
    <div v-if="isDuplicateFileName" class="invalid-msg">Файл с таким именем уже выбран</div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { requiredIf } from '@vuelidate/validators';

  export default {
    name: 'FileBaseMultiUploadRedesigned',
    props: {
      modelValue: {
        type: Array,
        required: true,
      },
      label: {
        type: String,
        default: 'Выберите файл',
      },
      readonly: Boolean,
      required: {
        type: Boolean,
        default: false,
      },
      accept: String,
      description: String,
      showEmpty: {
        type: Boolean,
        default: false,
      },
      isOnce: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      validExtensions: {
        type: Array,
        default: () => [],
      },
    },
    emits: ['addFile'],
    data() {
      return {
        isValidFileExtension: true,
        isDuplicateFileName: false,
      };
    },
    computed: {
      isEmptyValue() {
        return Array.isArray(this.modelValue) ? this.modelValue.length === 0 : !this.modelValue;
      },
    },
    methods: {
      fileChanged(e) {
        this.isValidFileExtension = true;
        this.isDuplicateFileName = false;

        const existingNamesSet = !this.isOnce
          ? new Set(this.modelValue.map((existingFile) => existingFile?.name))
          : null;

        Array.from(e.target.files).forEach((file) => {
          const fileName = file.name;

          if (!this.isValidFile(fileName)) {
            this.isValidFileExtension = false;
            return;
          }

          if (existingNamesSet && existingNamesSet.has(fileName)) {
            this.isDuplicateFileName = true;
            return;
          }

          if (existingNamesSet) existingNamesSet.add(fileName);

          this.$emit('addFile', file);
        });

        e.target.value = '';
      },
      isValidFile(filename) {
        if (!this.validExtensions.length) return true;

        const matchResult = filename.match(/\.(\w+)$/);
        const extension = matchResult?.[1].toLowerCase();

        return this.validExtensions.includes(extension);
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        modelValue: {
          required: requiredIf(function () {
            return this.required;
          }),
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../../../assets/theme/default/colors';
  ::-webkit-file-upload-button {
    cursor: pointer;
  }
  input[type='file'] {
    cursor: pointer;
  }
  .input-file {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
    border-radius: 6px;
    z-index: 2;
  }
  .input-file-btn {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    font: $fira-14-20-M;
    font-size: 15px;
    font-weight: 500 !important;
    z-index: 3;
    margin-bottom: 0;
    white-space: nowrap;
    padding: 12px 24px;
    border-radius: 4px;
    transition: 0.3s;
    color: #0791ba;
    background-color: #ffffff;
    border: 1px solid #0791ba;

    &:hover {
      opacity: 0.7;
      border-color: #0087e0;
    }
  }
  a:focus {
    box-shadow: none !important;
    outline: none !important;
  }

  .fileUpload {
    &-bordered {
      border-radius: 8px;
      border: 1px solid rgba(45, 51, 69, 0.16);
      padding: 32px;
      display: flex;
      align-items: center;
      gap: 24px;
      background-color: #fbfbfb;

      @media (max-width: $laptop) {
        flex-direction: column;
      }
    }
    &-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
      letter-spacing: 0.15px;
      width: 100%;
    }
    &__empty {
      text-align: center;
      white-space: nowrap;
    }
    &__error {
      margin: -8px 0 0 0;
      white-space: nowrap;
    }
  }

  .inner-file {
    display: flex;
    align-items: center;
    gap: 24px;

    @media (max-width: $laptop-2) {
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }

    .label-wrapper {
      &_disabled {
        cursor: not-allowed;

        label {
          pointer-events: none;
        }
      }
    }
  }
</style>
